export default __webpack_public_path__ + "static/media/layout-1.3d980a27.jpg";